import { LZString } from "../../hardware/LZString";
import { mathlib } from "../../hardware/mathlib";
import { aes128 } from "../../hardware/sha256";
import { MoYu32CubeConnection } from "./MoYu32CubeConnection";

const MOYU32_CIC_LIST = mathlib.valuedArray(255, function (i) { return (i + 1) << 8 });;
const SERVICE_UUID = '0783b03e-7735-b5a0-1760-a305d2795cb0';
const CHRT_UUID_READ = '0783b03e-7735-b5a0-1760-a305d2795cb1';
const CHRT_UUID_WRITE = '0783b03e-7735-b5a0-1760-a305d2795cb2';
const ENCRYPTION_KEYS = ['NoJgjANGYJwQrADgjEUAMBmKAWCP4JNIRswt81Yp5DztE1EB2AXSA', 'NoRg7ANAzArNAc1IigFgqgTB9MCcE8cAbBCJpKgeaSAAxTSPxgC6QA'];

export interface BluetoothDeviceWithMAC extends BluetoothDevice {
    mac?: string;
};

/** Iterate over all known GAN cube CICs to find Manufacturer Specific Data */
export function getManufacturerDataBytes(manufacturerData: BluetoothManufacturerData | DataView): DataView | undefined {
    if (manufacturerData instanceof DataView) { // this is workaround for Bluefy browser
        return new DataView(manufacturerData.buffer.slice(2));
    }
    for (var id of MOYU32_CIC_LIST) {
        if (manufacturerData.has(id)) {
            console.log('[Moyu32Cube] found Manufacturer Data under CIC = 0x' + id.toString(16).padStart(4, '0'));
            return manufacturerData.get(id);
        }
    }
}

/**
 * Type representing function interface to implement custom MAC address provider
 * @param device Current BluetoothDevice selected by user.
 * @param isFallbackCall Flag indicating this is final and last resort call for MAC address.
 *                       If this flag is not set, custom provider can return null instead of MAC,
 *                       in such case library will try to read MAC automatically.
 */
type MacAddressProvider = (device: BluetoothDevice, isFallbackCall?: boolean) => Promise<string | null>;

/**
 * Initiate new connection with the GAN Smart Cube device
 * @param customMacAddressProvider Optional custom provider for cube MAC address
 * @returns Object representing connection API and state
 */
async function connectGanCube(customMacAddressProvider?: MacAddressProvider): Promise<MoYu32CubeConnection> {

    // Request user for the bluetooth device (popup selection dialog)
    var device: BluetoothDeviceWithMAC = await navigator.bluetooth.requestDevice(
        {
            filters: [
                { namePrefix: "WCU_MY3" }
            ],
            optionalServices: [SERVICE_UUID],
            optionalManufacturerData: MOYU32_CIC_LIST
        }
    );

    // Retrieve cube MAC address needed for key salting
    var mac = customMacAddressProvider && await customMacAddressProvider(device, true);

    if (!mac)
        throw new Error('Unable to determine cube MAC address, connection is not possible!');
    device.mac = mac;

    // Connect to GATT and get device primary services
    var gatt = await device.gatt!.connect();
    var service = await gatt.getPrimaryService(SERVICE_UUID);;

    var conn: MoYu32CubeConnection | null = null;

    // Resolve type of connected cube device and setup appropriate encryption / protocol driver
    
    //let commandCharacteristic = await service.getCharacteristic(def.GAN_GEN4_COMMAND_CHARACTERISTIC);
    let stateReadCharacteristic = await service.getCharacteristic(CHRT_UUID_READ);
    let stateWriteCharacteristic = await service.getCharacteristic(CHRT_UUID_WRITE);

    var value = [];
    for (var i = 0; i < 6; i++) {
        value.push(parseInt(mac.slice(i * 3, i * 3 + 2), 16));
    }
    var keyiv = getKeyAndIv(value);
    let encrypter = aes128(keyiv[0]) as any;
    encrypter.iv = keyiv[1];

    //let encrypter = aes128(JSON.parse(LZString.decompressFromEncodedURIComponent(ENCRYPTION_KEYS[0])!)) as any;
    //encrypter.iv = LZString.decompressFromEncodedURIComponent(ENCRYPTION_KEYS[1])!
    //let driver = new GanGen4ProtocolDriver();
    conn = await MoYu32CubeConnection.create(device, stateReadCharacteristic, stateWriteCharacteristic, encrypter);
    
    if (!conn)
        throw new Error("Can't find target BLE services - wrong or unsupported cube device model");

    return conn;

}


	function getKeyAndIv(value: any[]) {
		var key = JSON.parse(LZString.decompressFromEncodedURIComponent(ENCRYPTION_KEYS[0])!);
		var iv = JSON.parse(LZString.decompressFromEncodedURIComponent(ENCRYPTION_KEYS[1])!);
		for (var i = 0; i < 6; i++) {
			key[i] = (key[i] + value[5 - i]) % 255;
			iv[i] = (iv[i] + value[5 - i]) % 255;
		}
		return [key, iv];
	}


export {
    connectGanCube
};

